import API from "../axiosConfig";

export const searchPayementByFilter = async (filters) => {
  try {
    const params = {};
    if (filters.reference) params.reference = filters.reference;

    if (filters.type_infraction_id)
      params.type_infraction_id = filters.type_infraction_id;

    if (filters.start_date && filters.end_date) {
      params.start_date = filters.start_date;
      params.end_date = filters.end_date;
    }
    if (filters.id_agent) params.id_agent = filters.id_agent;
    if (filters.payment_method) params.payment_method = filters.payment_method;
    if (filters.source) params.source = filters.source;
    if (filters.payment_type) params.payment_type = filters.payment_type;
    if (filters.min_amount !== null && filters.min_amount !== undefined) params.min_amount = filters.min_amount;
    if (filters.max_amount !== null && filters.max_amount !== undefined) params.max_amount = filters.max_amount;

    const response = await API.get("/payments/search", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSubscriptionPaymentsByZone = async (filters) => {
  try {
    const params = {};
    if (filters.month) params.month = filters.month;
    if (filters.year) params.year = filters.year;
    if (filters.payment_method) params.payment_method = filters.payment_method;

    const response = await API.get("/payments/subscription-by-zone", { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const changePaymentDetails = async (paymentId, paymentData) => {
  try {
    const response = await API.put(`/payments/${paymentId}/change-details`, paymentData);
    return response.data;
  } catch (error) {
    throw error;
  }
};
